module.exports = __webpack_public_path__ + "assets/ParallelogramBySPDetailed.ab26fbf1b6a304404125eb0f5744bdb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ParallelogramBySPDetailed.png
// module id = 547
// module chunks = 0